/**
 * Numero di telefono → cifre per WhatsApp (modulo puro, senza React ne' Supabase,
 * cosi' i test girano in ambiente node).
 *
 * Regole: via spazi, trattini e parentesi; via il "+" o lo "00" iniziale; un
 * numero locale senza prefisso (fino a 10 cifre) riceve il 39 davanti; un
 * cellulare di 10 cifre che inizia per 3 lo riceve sempre, anche se inizia per
 * 39 (es. 3931234567 → 393931234567). Un JID
 * (39333…@c.us, gruppi 1203…-16…@g.us, @lid) NON viene toccato: torna la parte
 * prima della chiocciola cosi' com'e', perche' non e' un numero di telefono.
 */
/** Etichetta leggibile di un numero aziendale: le config WAHA lo salvano come JID, i Cloud gia' con "+" e spazi. */
export function etichettaNumero(phoneNumber: string | null | undefined): string {
  const cifre = (phoneNumber || '').split('@')[0].replace(/\D/g, '');
  return cifre ? `+${cifre}` : '';
}

/**
 * Cellulare italiano scritto senza prefisso: 10 cifre che iniziano per 3.
 * Anche 3931234567 (un cellulare che inizia per 39x) e' un cellulare senza
 * prefisso, non un numero gia' con il 39: con il prefisso sarebbero 12 cifre.
 */
export function isItalianMobileWithoutPrefix(digits: string): boolean {
  return digits.length === 10 && digits.startsWith('3');
}

export function normalizeWhatsAppDigits(raw: string | null | undefined): string {
  const testo = (raw || '').trim();
  if (!testo) return '';
  if (testo.includes('@')) return testo.split('@')[0];
  let digits = testo.replace(/[^\d+]/g, '');
  const international = digits.startsWith('+') || digits.startsWith('00');
  if (digits.startsWith('+')) digits = digits.substring(1);
  digits = digits.replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.substring(2);
  if (!digits) return digits;
  // Senza "+" o "00": 10 cifre che iniziano per 3 = cellulare italiano, il 39 va sempre davanti.
  if (!international && isItalianMobileWithoutPrefix(digits)) return `39${digits}`;
  if (!digits.startsWith('39') && digits.length <= 10) digits = `39${digits}`;
  return digits;
}
